import { SignInWithAppleOptions } from "@capacitor-community/apple-sign-in";

export const appleSignInOptions: SignInWithAppleOptions = {
  clientId: process.env.REACT_APP_APPLE_CLIENT_ID as string,
  redirectURI: window.location.origin + "/signin",
  scopes: "email name",
  // state: "12345",
  // nonce,
};
